export enum IncidentStatus {
  None = 'None',
  Pending = 'Pending',
  Disabled = 'Disabled',
  Active = 'Active',
}
